import { useBetaFeatureEnabled } from '@shared/hooks';
import { BETA_SERVER_CUSTOM_PANELS } from '@/lib/betaFeatures';

const useIsServerCustomPanelsEnabled = () => {
  return useBetaFeatureEnabled(BETA_SERVER_CUSTOM_PANELS);
};

export default useIsServerCustomPanelsEnabled;
